import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/esnext.json.parse.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import Icon from "@/components/icon/Icon.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
import WDialog from "@/components/wrappers/w-dialog.vue";
import { AIAvatarGender } from "@/models/ai/enum/aiAvatarGender.enum";
import { LIST_OF_VOICES, getVoiceUseCases } from "@/models/ai/aiAvatarReferential.model";
const FAVORITES_KEY = "speach.ai.tts_favorite_voices";
let VoiceSelectorModal = class VoiceSelectorModal extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "active", void 0);
    /** Currently selected voice, to preselect when opening. */
    _defineProperty(this, "voice", void 0);
    /** Locks the list to a gender (MALE/FEMALE). Empty = show the gender filter. */
    _defineProperty(this, "gender", void 0);
    _defineProperty(this, "advancedTtsEnabled", void 0);
    _defineProperty(this, "selectedVoiceId", '');
    _defineProperty(this, "genderFilter", '');
    _defineProperty(this, "useCaseFilter", '');
    _defineProperty(this, "showFavoritesOnly", false);
    _defineProperty(this, "favorites", []);
    _defineProperty(this, "playingVoiceId", null);
    _defineProperty(this, "previewAudio", null);
  }
  mounted() {
    this.loadFavorites();
  }
  onActiveChange() {
    if (this.active) {
      this.selectedVoiceId = this.voice;
      this.loadFavorites();
    } else {
      this.stopPreview();
    }
  }
  /**
   * Voices after advanced-TTS + gender constraints — feeds both the use-case options and the grid.
   * Advanced TTS enabled → advanced voices only; otherwise standard voices as a fallback.
   */
  get baseVoices() {
    let voices = LIST_OF_VOICES.filter(v => !!v.advanced === this.advancedTtsEnabled);
    const g = this.gender || this.genderFilter;
    if (g) {
      voices = voices.filter(v => v.gender === g || v.gender === AIAvatarGender.NEUTRAL || v.gender === AIAvatarGender.UNKNOWN);
    }
    return voices;
  }
  get useCaseOptions() {
    const set = new Set();
    for (const v of this.baseVoices) {
      for (const uc of getVoiceUseCases(v.voice)) {
        set.add(uc);
      }
    }
    return Array.from(set).sort();
  }
  get filteredVoices() {
    let list = this.baseVoices;
    if (this.useCaseFilter) {
      list = list.filter(v => getVoiceUseCases(v.voice).indexOf(this.useCaseFilter) !== -1);
    }
    if (this.showFavoritesOnly) {
      list = list.filter(v => this.isFavorite(v.voice));
    }
    return list;
  }
  get hasActiveFilter() {
    return this.genderFilter !== '' || this.useCaseFilter !== '' || this.showFavoritesOnly;
  }
  voiceMeta(voice) {
    return getVoiceUseCases(voice.voice).join(', ');
  }
  onGenderChange(value) {
    this.genderFilter = value;
    this.useCaseFilter = '';
  }
  onUseCaseChange(value) {
    this.useCaseFilter = value;
  }
  onFavToggle(value) {
    this.showFavoritesOnly = value;
  }
  selectVoice(voice) {
    this.selectedVoiceId = voice.voice;
  }
  // ─── Favorites (client-side only) ─────────────────────────────────────
  loadFavorites() {
    try {
      this.favorites = JSON.parse(localStorage.getItem(FAVORITES_KEY) || '[]');
    } catch (e) {
      this.favorites = [];
    }
  }
  isFavorite(id) {
    return this.favorites.indexOf(id) !== -1;
  }
  toggleFavorite(id) {
    if (this.isFavorite(id)) {
      this.favorites = this.favorites.filter(f => f !== id);
    } else {
      this.favorites = [...this.favorites, id];
    }
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(this.favorites));
  }
  clearFilters() {
    this.genderFilter = '';
    this.useCaseFilter = '';
    this.showFavoritesOnly = false;
  }
  // ─── Preview (pre-rendered MP3 via the same-origin endpoint → 302 to the CDN) ──
  previewVoice(voice) {
    if (this.playingVoiceId === voice.voice) {
      this.stopPreview();
      return;
    }
    this.stopPreview();
    const provider = voice.provider || 'MICROSOFT';
    const audio = new Audio(`/recorder/aiSpeachGenerator/voicePreview?voiceId=${encodeURIComponent(voice.voice)}&provider=${provider}`);
    audio.onended = () => this.stopPreview();
    audio.onerror = () => this.stopPreview();
    this.previewAudio = audio;
    this.playingVoiceId = voice.voice;
    audio.play().catch(() => this.stopPreview());
  }
  stopPreview() {
    if (this.previewAudio) {
      this.previewAudio.pause();
      this.previewAudio = null;
    }
    this.playingVoiceId = null;
  }
  validate() {
    this.stopPreview();
    this.$emit('validate', {
      voice: this.selectedVoiceId
    });
    this.close();
  }
  close() {
    this.stopPreview();
    this.$emit('close');
  }
  beforeDestroy() {
    this.stopPreview();
  }
};
__decorate([Prop({
  default: false
})], VoiceSelectorModal.prototype, "active", void 0);
__decorate([Prop({
  default: ''
})], VoiceSelectorModal.prototype, "voice", void 0);
__decorate([Prop({
  default: ''
})], VoiceSelectorModal.prototype, "gender", void 0);
__decorate([Prop({
  default: false
})], VoiceSelectorModal.prototype, "advancedTtsEnabled", void 0);
__decorate([Watch('active')], VoiceSelectorModal.prototype, "onActiveChange", null);
VoiceSelectorModal = __decorate([Component({
  components: {
    Icon,
    StandardButton,
    WDialog
  },
  emits: ['validate', 'close']
})], VoiceSelectorModal);
export default VoiceSelectorModal;